<template lang="pug">
transition(name="modal-historico-editais-fade")
  .modal-historico-editais(v-if="visible" @keydown.esc="fechar")
    .modal-historico-editais__overlay(@click="fechar")
    .modal-historico-editais__dialog(role="dialog" aria-labelledby="modal-historico-editais-titulo")
      header.modal-historico-editais__header
        h2#modal-historico-editais-titulo.modal-historico-editais__title Histórico de editais
        button.modal-historico-editais__close(type="button" aria-label="Fechar" @click="fechar")
          i.fas.fa-times

      .modal-historico-editais__filters
        button.modal-historico-editais__filter(
          v-for="opcao in opcoesFiltro"
          :key="opcao.value || 'todos'"
          type="button"
          :class="{ 'modal-historico-editais__filter--active': filtroTipo === opcao.value }"
          @click="filtroTipo = opcao.value"
        ) {{ opcao.label }}

        label.modal-historico-editais__year-label Ano Publicação
        CadastroFormSearchSelect.modal-historico-editais__year-select(
          v-model="filtroAno"
          :options="anosDisponiveis"
          primitive-options
          placeholder="Selecione"
        )
        button.modal-historico-editais__clear(
          type="button"
          :disabled="!temFiltroAtivo"
          @click="limparFiltros"
        ) Limpar

      .modal-historico-editais__content(v-loading="carregando")
        .modal-historico-editais__list(v-if="editaisFiltrados.length")
          CardEdital(
            v-for="edital in editaisFiltrados"
            :key="edital.id"
            :titulo="edital.titulo"
            :subtitulo="edital.subtitulo"
            :descricao="edital.descricao"
            :publicacao="edital.publicacao"
            :encerramento-inscricoes="edital.encerramentoInscricoes"
            :encerramento-analises="edital.encerramentoAnalises"
            :modalidade="edital.modalidade"
            :inscricoes-abertas="false"
            :modo-historico="true"
            @download="downloadEdital(edital.id)"
          )

        p.modal-historico-editais__empty(v-else-if="!carregando")
          | {{ mensagemVazia }}
</template>

<script>
import CardEdital from '@/components/editais/CardEdital'
import CadastroFormSearchSelect from '@/components/cadastro/CadastroFormSearchSelect'
import { getEditaisHistorico } from '@/services/editalService'
import { EDITAL_CONTENT } from '@/constants/editaisPublico'
import util from '@/utils/utils'

const OPCOES_FILTRO = [
  { label: 'Todos', value: null },
  { label: 'Geomensor', value: 'GEOMENSOR' },
  { label: 'Vistoriador', value: 'VISTORIADOR' }
]

export default {
  name: 'ModalHistoricoEditais',
  components: {
    CardEdital,
    CadastroFormSearchSelect
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      carregando: false,
      filtroTipo: null,
      filtroAno: '',
      editais: [],
      opcoesFiltro: OPCOES_FILTRO
    }
  },
  computed: {
    anosDisponiveis () {
      const anoAtual = new Date().getFullYear()
      const anos = []

      for (let ano = anoAtual; ano >= 2000; ano -= 1) {
        anos.push(ano)
      }

      return anos
    },
    temFiltroAtivo () {
      return this.filtroTipo !== null || Boolean(this.filtroAno)
    },
    editaisFiltrados () {
      const anoSelecionado = this.filtroAno !== '' && this.filtroAno != null
        ? Number(this.filtroAno)
        : null

      return this.editais.filter((edital) => {
        const tipoOk = !this.filtroTipo || edital.tipoEdital === this.filtroTipo
        const anoOk = !anoSelecionado || edital.anoPublicacao === anoSelecionado

        return tipoOk && anoOk
      })
    },
    mensagemVazia () {
      if (this.temFiltroAtivo && this.editais.length) {
        return 'Nenhum edital encerrado encontrado para este filtro.'
      }

      return 'Nenhum edital encerrado no momento.'
    }
  },
  watch: {
    visible (aberto) {
      document.body.style.overflow = aberto ? 'hidden' : ''

      if (aberto) {
        this.limparFiltros()
        this.carregarHistorico()
      }
    }
  },
  beforeDestroy () {
    document.body.style.overflow = ''
  },
  methods: {
    fechar () {
      this.$emit('close')
    },

    limparFiltros () {
      this.filtroTipo = null
      this.filtroAno = ''
    },

    async carregarHistorico () {
      this.carregando = true

      try {
        const response = await getEditaisHistorico()
        const lista = Array.isArray(response) ? response : []

        this.editais = lista
          .filter((edital) => edital && edital.id && edital.tipoEdital)
          .map((edital) => this.mapEdital(edital))
          .filter(Boolean)
      } catch (erro) {
        this.editais = []
      } finally {
        this.carregando = false
      }
    },

    mapEdital (edital) {
      const conteudo = EDITAL_CONTENT[edital.tipoEdital]

      if (!conteudo) {
        return null
      }

      const anoPublicacao = edital.dataInicio
        ? Number(util.formatDate(edital.dataInicio, 'YYYY'))
        : null

      return {
        id: edital.id,
        tipoEdital: edital.tipoEdital,
        anoPublicacao: Number.isInteger(anoPublicacao) ? anoPublicacao : null,
        titulo: conteudo.titulo,
        subtitulo: `Nº ${edital.numero} · ITERPA / SICARF · Georreferenciamento Fundiário`,
        descricao: conteudo.descricao,
        publicacao: util.formatDate(edital.dataInicio),
        encerramentoInscricoes: util.formatDate(edital.dataFim),
        encerramentoAnalises: util.formatDate(edital.dataFim),
        modalidade: conteudo.modalidade
      }
    },

    downloadEdital (idEdital) {
      if (!idEdital) {
        return
      }

      const urlBase = process.env.VUE_APP_ROOT_URL
      window.open(`${urlBase}/publico/edital/baixar?idEdital=${idEdital}`, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-historico-editais {
  inset: 0;
  position: fixed;
  z-index: 3000;
}

.modal-historico-editais__overlay {
  background: rgba(0, 0, 0, 0.4);
  inset: 0;
  position: absolute;
}

.modal-historico-editais__dialog {
  background: #ffffff;
  border: 1px solid #eaeaea;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  left: 50%;
  max-height: calc(100vh - 48px);
  max-width: 900px;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: calc(100% - 32px);
  z-index: 1;
}

.modal-historico-editais__header {
  align-items: center;
  border-bottom: 1px solid #eaeaea;
  display: flex;
  justify-content: space-between;
  padding: 16px 20px;
}

.modal-historico-editais__title {
  color: #141414;
  font-family: 'Poppins', 'Ubuntu', sans-serif;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.4;
  margin: 0;
}

.modal-historico-editais__close {
  align-items: center;
  background: transparent;
  border: none;
  border-radius: 8px;
  color: #141414;
  cursor: pointer;
  display: inline-flex;
  flex-shrink: 0;
  height: 40px;
  justify-content: center;
  transition: background-color 0.2s ease;
  width: 40px;

  i {
    font-size: 16px;
  }

  &:hover {
    background: #f5f5f5;
  }
}

.modal-historico-editais__filters {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 16px 20px 0;
  position: relative;
  z-index: 2;
}

.modal-historico-editais__filter {
  background: #ffffff;
  border: 1px solid #eaeaea;
  border-radius: 9999px;
  color: #4c4c4c;
  cursor: pointer;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 13px;
  font-weight: 500;
  height: 32px;
  padding: 0 14px;
  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;

  &:hover {
    border-color: #1e174e;
    color: #1e174e;
  }

  &--active {
    background: #1e174e;
    border-color: #1e174e;
    color: #ffffff;

    &:hover {
      background: #1e174e;
      color: #ffffff;
      opacity: 0.92;
    }
  }
}

.modal-historico-editais__year-label {
  color: #4c4c4c;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 13px;
  font-weight: 500;
  margin-left: 8px;
  white-space: nowrap;
}

.modal-historico-editais__year-select {
  flex: 0 0 128px;
  max-width: 128px;
  width: 128px;

  ::v-deep .cadastro-form-search-select__input {
    border-radius: 9999px;
    font-size: 13px;
    height: 32px;
    padding: 0 30px 0 12px;
  }

  ::v-deep .cadastro-form-search-select__chevron {
    height: 14px;
    right: 10px;
    width: 14px;
  }

  ::v-deep .cadastro-form-search-select__dropdown {
    border-radius: 12px;
    max-height: 200px;
  }

  ::v-deep .cadastro-form-search-select__option,
  ::v-deep .cadastro-form-search-select__empty {
    font-size: 13px;
    padding: 6px 12px;
  }
}

.modal-historico-editais__clear {
  background: transparent;
  border: none;
  color: #1e174e;
  cursor: pointer;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 13px;
  font-weight: 500;
  height: 32px;
  padding: 0 4px;
  text-decoration: underline;
  transition: opacity 0.2s ease;

  &:hover:not(:disabled) {
    opacity: 0.75;
  }

  &:disabled {
    color: #8a8a8a;
    cursor: not-allowed;
    opacity: 0.6;
    text-decoration: none;
  }
}

.modal-historico-editais__content {
  flex: 1;
  min-height: 160px;
  overflow-y: auto;
  padding: 16px 20px 20px;
}

.modal-historico-editais__list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.modal-historico-editais__empty {
  color: #8a8a8a;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 14px;
  margin: 24px 0;
  text-align: center;
}

.modal-historico-editais-fade-enter-active,
.modal-historico-editais-fade-leave-active {
  transition: opacity 0.25s ease;

  .modal-historico-editais__dialog {
    transition: opacity 0.25s ease, transform 0.25s ease;
  }
}

.modal-historico-editais-fade-enter,
.modal-historico-editais-fade-leave-to {
  opacity: 0;

  .modal-historico-editais__dialog {
    transform: translate(-50%, calc(-50% + 12px));
  }
}

@media (max-width: 640px) {
  .modal-historico-editais__dialog {
    border-radius: 12px 12px 0 0;
    bottom: 0;
    left: 0;
    max-height: 90vh;
    top: auto;
    transform: none;
    width: 100%;
  }

  .modal-historico-editais-fade-enter,
  .modal-historico-editais-fade-leave-to {
    .modal-historico-editais__dialog {
      transform: translateY(16px);
    }
  }
}
</style>
